// Angular Core
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

// MaterialModules
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

//Interfaces
import { Configs } from '../../interfaces/GenericInputConfigs';

//Services
import { InputMaskService } from '../../services/input-mask/input-mask.service';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'GenericInput',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  templateUrl: './generic-input.component.html',
  styleUrls: ['./generic-input.component.scss']
})
export class GenericInput {
  @Input() configs !: Configs;
  @Input() form !: FormGroup;
  @Input() format : string = ''

  @Output() prefixIconEmitter: EventEmitter<null> = new EventEmitter<null>()
  @Output() suffixIconEmitter: EventEmitter<null> = new EventEmitter<null>()
  @Output() inputValueEmitter: EventEmitter<any> = new EventEmitter<any>()

  // Dependency Injections
  private maskService: InputMaskService = inject(InputMaskService)

  mapFormFieldType(): string {
    return this.configs.formFieldType === 'fill' ? 'form-field-fill' : 'form-field-outline';
  }

  returnCorrectMask(): string {
    return this.maskService.returnCorrectMaskFormat(this.format)
  }

  emitPrefixIconClick(): void {
    this.prefixIconEmitter.emit()
  }

  emitSuffixIconClick(): void {
    this.suffixIconEmitter.emit()
  }

  emitInputValue(event: any): void {
    this.inputValueEmitter.emit(event)
  }

  emitInputOutOfFocus(event: any) {
    this.inputValueEmitter.emit(event)
  }
}
